<div class="toggle" [ngClass]="disabled ? 'disabled' : ''">
  <span class="toggle__label fs__sm fw__500">{{ label }}</span>
  <label class="toggle__switch" (click)="$event.stopPropagation()">
    <input class="toggle__switch__input" [formControl]="control" type="checkbox" />
    <div class="toggle__switch__handle"></div>
  </label>
</div>
